import { FC, ReactNode } from 'react';
import WizardPage, { WizardPageProps } from './WizardPage';
import WizardSidebar, { WizardSidebarProps } from './WizardSidebar';
import WizardSteps, { WizardStepsProps } from './WizardSteps';
import { WizardSx } from './types';

export interface WizardProps {
    children: ReactNode;
    className?: string;
    sx?: WizardSx;
}

const Wizard: FC<WizardProps> & {
    Page: FC<WizardPageProps>;
    Sidebar: FC<WizardSidebarProps>;
    Steps: FC<WizardStepsProps>;
} = ({ children, className = '', sx }) => {
    return (
        <div className={`w-full h-full font-sf bg-sf-gray-50 p-6 flex gap-4 ${className}`} style={sx?.root}>
            {children}
        </div>
    );
};

Wizard.Steps = WizardSteps;
Wizard.Page = WizardPage;
Wizard.Sidebar = WizardSidebar;

export default Wizard;
